import { AlertTriangle } from "lucide-react";

import { Alert } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

interface ErrorBannerProps {
  message: string | null;
  className?: string;
}

export function ErrorBanner({ message, className }: ErrorBannerProps) {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="destructive" icon={<AlertTriangle className="size-4" />} className={cn("text-sm", className)}>
      {message}
    </Alert>
  );
}
